import Blue from "~/core";

// Gallery banners (Development Excellence Principles widget and Case Study pages): opens the banner images in a lightbox
// that can be paged through (prev/next buttons, arrow keys, click outside or Esc to close).
new Blue({
  name: "GalleryLightbox",
  selector: ".gallery-banners",
  setup(gallery) {
    const tiles = [...gallery.querySelectorAll(".gallery-banner")];
    const dialog = gallery.querySelector(".gallery-lightbox");
    if (!dialog || !tiles.length || typeof dialog.showModal !== "function") return;

    const image = dialog.querySelector(".gallery-lightbox__img");
    const closeBtn = dialog.querySelector(".gallery-lightbox__close");
    const prevBtn = dialog.querySelector(".gallery-lightbox__prev");
    const nextBtn = dialog.querySelector(".gallery-lightbox__next");

    let index = 0;

    const switchTo = (newIndex) => {
      index = (newIndex + tiles.length) % tiles.length;
      const tile = tiles[index];
      image.src = tile.href;
      image.alt = tile.querySelector("img")?.alt || "";
    };

    if (tiles.length < 2) {
      prevBtn.hidden = true;
      nextBtn.hidden = true;
    }

    tiles.forEach((tile, tileIndex) => {
      this.$addEvents(tile, "click", (e) => {
        e.preventDefault();
        switchTo(tileIndex);
        dialog.showModal();
      });
    });

    this.$addEvents(closeBtn, "click", () => dialog.close());
    this.$addEvents(prevBtn, "click", () => switchTo(index - 1));
    this.$addEvents(nextBtn, "click", () => switchTo(index + 1));

    // Clicking the dimmed backdrop (the dialog element itself) closes it
    this.$addEvents(dialog, "click", (e) => {
      if (e.target === dialog) dialog.close();
    });

    this.$addEvents(dialog, "keydown", (e) => {
      if (e.key === "ArrowLeft") switchTo(index - 1);
      if (e.key === "ArrowRight") switchTo(index + 1);
    });
  },
});
